import { element } from './dom';

export type QuestionProgressStep = 'birth_date'|'focus';
export type QuestionProgressState = 'completed'|'current'|'future';

const stepNumber:Record<QuestionProgressStep,number>={birth_date:1,focus:2};

export function questionProgressStates(step:QuestionProgressStep):QuestionProgressState[]{
  const current=stepNumber[step];
  return Array.from({length:2},(_,index)=>index+1<current?'completed':index+1===current?'current':'future');
}

export function questionProgress(step:QuestionProgressStep):HTMLElement{
  const current=stepNumber[step];
  const progress=element('div',{className:'step-dots two',attrs:{role:'progressbar','aria-label':`Question ${current} of 2`,'aria-valuemin':'1','aria-valuemax':'2','aria-valuenow':String(current)}});
  questionProgressStates(step).forEach((state)=>progress.append(element('span',{className:state,attrs:{'data-state':state,'aria-hidden':'true'}})));
  return progress;
}
